var s=Promise.all.bind(Promise),r=e=>new Promise(o=>setTimeout(o,e));export{s as a,r as b};
//# sourceMappingURL=chunk-WMODJPMY.js.map